import apiUrl from '../../../constants'
import axios from 'axios'
export default new class {

	async validateBox(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateBox',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async splitBoxPacking(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'splitBoxPacking',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getSplitBoxDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getSplitBoxDetails',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	
	async changeBoxStatus(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/changeBoxStatus',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async completeBoxPacking(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/completeBoxPacking',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getrubiconInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getrubiconInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getInvoiceWMS(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getinvoicedata',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getUnicommerceInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getUnicommerceInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getFlipkartInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getFlipkartInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getBoxDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/getBoxDetailsb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async scanProductPacking(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/scanProductPacking',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateQcDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/packingProductQC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getWarehouseList(token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': {},
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getWeight(token) {
		try {
			let result = await axios({
				'method': 'GET',
				'url': apiUrl.local_printer_api_url + 'getWeight',
				'data': {},
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async saveWeight(input,token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/addBoxWeightb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};


	async saveOrderWeight(input,token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/addOrderweightb2b',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async addinvoicedetails(input,token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/addinvoicedetails',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async b2bQclisting(input,token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/b2bpackedorderlisting',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async b2bpackedboxlisting(input,token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'b2bpacking/b2bpackedboxlisting',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getEancodeFlag(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'checkEancodeManualEntry',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getAutoFillBoxFlag(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'checkAutofillBox',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
}


// WEBPACK FOOTER //
// ./src/views/components/packingb2b/packingb2b.js